import { useI18n } from 'vue-i18n'

import eventBus, { eventNames } from '@/lib/eventBus'

export const useImageErrorHandling = () => {
  const { t } = useI18n()

  const showSuccessMessage = (message?: string) => {
    eventBus.$emit(eventNames.SHOW_SNACKBAR, {
      color: 'success',
      text: message || t('alerts.image-edit.success'),
    })
  }

  const showErrorMessage = (message?: string) => {
    eventBus.$emit(eventNames.SHOW_SNACKBAR, {
      color: 'error',
      text: message || t('alerts.image-edit.error'),
    })
  }

  const showWarningMessage = (message: string) => {
    eventBus.$emit(eventNames.SHOW_SNACKBAR, {
      color: 'warning',
      text: message,
    })
  }

  const handleGraphQLError = (error: Error): string | null => {
    // Handle specific GraphQL errors
    const graphQLError = (error as { graphQLErrors?: Array<{ extensions?: { code?: string } }> })
      .graphQLErrors?.[0]

    if (graphQLError) {
      switch (graphQLError.extensions?.code) {
        case 'NOT_FOUND':
          showErrorMessage(t('alerts.image-edit.not-found'))
          break
        case 'FORBIDDEN':
          showErrorMessage(t('alerts.image-edit.forbidden'))
          break
        case 'BAD_REQUEST':
          showErrorMessage(t('alerts.image-edit.bad-request'))
          break
        case 'NOT_IMPLEMENTED':
          showErrorMessage(t('alerts.image-edit.not-implemented'))
          break
        default:
          showErrorMessage(t('alerts.image-edit.error'))
      }
      return graphQLError.extensions?.code || null
    } else {
      showErrorMessage(t('alerts.image-edit.error'))
      return null
    }
  }

  return {
    showSuccessMessage,
    showErrorMessage,
    showWarningMessage,
    handleGraphQLError,
  }
}
